import { useState } from "react";
import type { AxiosError } from "axios";
import { toast } from "@/utils/toast";
import { EStorage } from "@/constants/enums/storage.enum";
import { useFileUpload } from "@/hooks/file-upload/file-upload.hook";

export const useGroupLifeInsuranceCertificates = () => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [certificateUrls, setCertificateUrls] = useState<string[]>([]);

  const { mutate: uploadCertificate, isPending: isUploadingCertificate } =
    useFileUpload();

  const handleFilesSelect = (files: File[]) => {
    setSelectedFiles(files);

    if (files.length === 0) {
      setCertificateUrls([]);
      return;
    }

    uploadCertificate(
      {
        file: files.length === 1 ? files[0] : files,
        path: EStorage.GROUP_LIFE_INSURANCE,
        document_type: EStorage.GROUP_LIFE_INSURANCE,
      },
      {
        onSuccess: (
          response:
            | {
                data?: { urls?: string[]; url?: string };
                urls?: string[];
                url?: string;
              }
            | string[]
        ) => {
          toast.success("Certificate(s) uploaded successfully!");
          let urls: string[] = [];

          if (files.length === 1) {
            const url = Array.isArray(response)
              ? response[0]
              : response?.url
                ? response.url
                : response?.data?.url
                  ? response.data.url
                  : "";
            if (url) urls = [url];
          } else {
            urls = Array.isArray(response)
              ? response
              : response?.urls
                ? response.urls
                : response?.data?.urls
                  ? response.data.urls
                  : [];
          }

          setCertificateUrls(urls);
        },
        onError: (error: unknown) => {
          const errorMessage = error as AxiosError<{ message?: string }>;
          toast.error(
            errorMessage.response?.data?.message ||
              "Failed to upload certificate(s)"
          );
          setSelectedFiles([]);
          setCertificateUrls([]);
        },
      }
    );
  };

  const handleFileRemoveAt = (index: number) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    setCertificateUrls((prev) => prev.filter((_, i) => i !== index));
    toast.info("File removed successfully");
  };

  return {
    selectedFiles,
    certificateUrls,
    setCertificateUrls,
    isUploadingCertificate,
    handleFilesSelect,
    handleFileRemoveAt,
  };
};

